import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getRoutes } from '../../utils/router/getRoutes';

/**
 * @description FallbackRedirect is a React functional component that serves as a fallback route for undefined paths in the application.
 *
 * It uses the useLocation hook from react-router-dom to access the current location and then redirects the user to a specified base path while preserving any query parameters.
 */
export const FallbackRedirect: FC = () => {
  const location = useLocation();

  const { formStepRoutes } = getRoutes();

  const fallbackRoute = formStepRoutes[0].path;

  return <Navigate to={`${fallbackRoute}${location.search}`} replace />;
};
